import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Select the specific scrolling div from your Layout
    const mainContainer = document.querySelector('.overflow-y-auto.custom-scrollbar');

    if (mainContainer) {
      // Apply smooth scroll effect natively
      mainContainer.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // Native browser smooth scroll (Zero performance hit)
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;